var common = require("../../utiles/common")
var metaService = require("../../services/metaService")

module.exports = {
    register: function () {
        document.createElement('form-item1')
        ko.components.register('form-item1', {
            viewModel: function (params) {
                var $this = this;
                $this.params = params.app;
                $this.type = $this.params.type?$this.params.type:"input";
                $this.verify = $this.params.rules?$this.params.rules.join("|"):"";
                $this.required = $this.verify.indexOf("required")>-1;
                $this.code = $this.params.code;
                $this.name = $this.params.name;
                $this.hide = $this.params.hide;
                $this.description = $this.params.description;
                $this.disabled = $this.params.disabled;
                $this.options = $this.params.options;
                $this.fieldName = $this.params.fieldName;
                console.log($this.fieldName)
                var fetch = 0;
                setTimeout(function(){
                    layui.use(["form"], function(){
                        var form = layui.form;
                        $this.refresh = function(value){
                            var options = metaService.queryDataByContains({
                                condition: {displayName: value},
                                dataTypeQualifyName: $this.params.dataTypeId
                            })
                            $this.options = options.result;
                            console.log($this.options)
                            form.render("select",$this.fieldName);
                        }
                        $this.search = function () {
                            var fieldName = $this.fieldName;
                            console.log($this)
                            var value = $("#selectInput"+fieldName).val();
                            console.log(value)
                            fetch +=1;
                            var lastIndex = fetch;
                            setTimeout(function(){
                                if(lastIndex === fetch){
                                    $this.refresh(value);
                                }
                            },50)
                        }
                        form.on("select("+$this.fieldName+")", function(data){
                            console.log(data)
                            if(params.selectChange){
                                params.selectChange(data);
                            }
                            if($this.type === "linkTo"){
                                var txt = data.elem[data.elem.selectedIndex].text;
                                $("#selectInput"+$this.fieldName).val(txt);
                                $("#"+$this.fieldName).next().find("dl").css({ "display": "none" });
                                form.render();
                            }
                        });
                        form.on('submit(*)', function(data){
                            return false;
                          });
                        form.on("checkbox("+$this.fieldName+")", function(data){
                            console.log(data)
                        });
                        
                    })
                    if($this.type === "date"){
                        layui.use('laydate', function(){
                            var laydate = layui.laydate;
                            laydate.render({
                              elem: '#'+$this.fieldName,
                              type:"datetime"
                            });
                        });
                    }
                },1)
            },
            template: require("./BFormItem.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/template/form/BFormItem.js
// module id = 70
// module chunks = 0